import { useEffect, useRef } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function formatApiError(detail) {
  if (!detail) return "Google sign-in could not be completed.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return detail.msg || String(detail);
}

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/admin/reels", { replace: true, state: { authError: "Missing Google session." } });
      return;
    }
    axios.post(
      `${API}/auth/google/session`,
      { session_id: sessionId },
      { withCredentials: true }
    ).then(({ data }) => {
      navigate("/admin/reels", { replace: true, state: { user: data } });
    }).catch((err) => {
      navigate("/admin/reels", {
        replace: true,
        state: { authError: formatApiError(err.response?.data?.detail) },
      });
    });
  }, [location.hash, navigate]);

  return null;
}
